import { AxiosResponse } from "axios";
import client from "../client";
import { getFormDetailsConfig } from "./GetFormDetailsConfig";
import { getFormDetailsResponse } from "./types";

const getFormDetails = ({
  pdfId,
  addons,
}: {
  pdfId: string;
  addons: boolean;
}): Promise<AxiosResponse<getFormDetailsResponse>> =>
  client({ ...getFormDetailsConfig(pdfId, addons) });

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getFormDetails,
};
